import axios from 'axios'
import store from '../store'
import ApiRequestStatus from '../enums/ApiRequestStatus'

export type IApiRequestStatus = typeof ApiRequestStatus[keyof typeof ApiRequestStatus]

export interface IApiRequestResult<T> {
    data: T | null | undefined
    status: IApiRequestStatus
}

interface IHeaders extends Record<string, unknown> {
    Authorization: string | undefined | null
}

export interface IRequestConfig {
    headers?: IHeaders
}

export const useApi = () => {
    const authenticate = async (): Promise<IRequestConfig> => {
        const accessToken = store.getState().auth.token

        if (accessToken) {
            return {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        }

        return {}
    }

    const execute = async <T>(
        fn: (cfg: IRequestConfig) => Promise<T>
    ): Promise<IApiRequestResult<T>> => {
        try {
            console.log('config')

            const config = await authenticate()
            console.log(config)
            const res = await fn(config)
            return createApiResponse(res)
        } catch (e) {
            return createApiError(e)
        }
    }

    const executeUnauthenticated = async <T>(
        fn: (cfg: IRequestConfig) => Promise<T>
    ): Promise<IApiRequestResult<T>> => {
        try {
            const res = await fn({})
            return createApiResponse(res)
        } catch (e) {
            return createApiError(e)
        }
    }

    const createApiResponse = <T>(data: T): IApiRequestResult<T> => {
        return {
            data,
            status: ApiRequestStatus.Success,
        }
    }

    const createApiError = <T>(e: any): IApiRequestResult<T> => {
        if (axios.isAxiosError(e)) {
            if (e?.response?.status === 401) {
                return {
                    data: null,
                    status: ApiRequestStatus.Unauthorised,
                }
            } else if (e?.response?.status === 403) {
                return {
                    data: null,
                    status: ApiRequestStatus.Forbidden,
                }
            } else if (e?.response?.status === 400) {
                return {
                    data: null,
                    status: ApiRequestStatus.BadRequest,
                }
            } else if (e?.response?.status === 409) {
                return {
                    data: null,
                    status: ApiRequestStatus.Conflict,
                }
            } else if (e?.response?.status === 404) {
                return {
                    data: null,
                    status: ApiRequestStatus.NotFound,
                }
            }
        }

        return {
            data: null,
            status: ApiRequestStatus.UnknownError,
        }
    }

    return {
        execute,
        executeUnauthenticated,
        createApiResponse,
        createApiError,
    }
}
